// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddContact.css */
.add-contact {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  /* width: 100vw; */
  max-width: 430px;
  max-height: 900px;
  /* margin: 0 auto; */
  height: 100vh;
  background-color: rgb(243 243 243);
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 40px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.1);
  position: relative; /* For positioning the header */
}


.profile {
  font-size: 72px !important;
  color: white;
}

.add-contact-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f7f7f7;
  border-bottom: 1px solid #ccc;
}

.header-button, .header-button-link {
  font-size: 17px;
  color: #007aff;
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer; /* Makes it clear that it's clickable */
  text-decoration: none; /* Removes underline from links */
}

/* If you're using a class specifically for links, you can also do this */
.header-button-link {
  display: inline-block; /* Allows padding and width/height if needed */
}

.add-photo-section {
  text-align: center;
  padding: 20px;
}

.photo-placeholder {
  width: 90px;
  height: 90px;
  background-color: #c7c7cc;
  border-radius: 50%;
  margin: 0 auto 10px;
  /* Add your 'add photo' icon here */
}

.add-photo-button {
  background-color: #c7c7cc;
  border: none;
  border-radius: 1em;
  color: black;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
}

.add-contact-form {
  padding: 20px;
}

.add-contact-form input {
  width: 100%;
  font-size: 17px;
  padding: 10px 0;
  border: none;
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}

.add-contact-form input::placeholder {
  color: #c7c7cc;
}

.add-field-button {
  background: none;
  border: none;
  color: #007aff;
  padding: 10px;
  text-align: left;
  width: 100%;
  margin-bottom: 15px;
  font-size: 17px;
}

/* For the submit button, if you still need it */
.add-contact-form button[type="submit"] {
  display: none; /* Hide it if you're using the Done button in the header */
}
`, "",{"version":3,"sources":["webpack://./src/components/css/AddContact.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,kBAAkB,EAAE,+BAA+B;AACrD;;;AAGA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe,EAAE,uCAAuC;EACxD,qBAAqB,EAAE,iCAAiC;AAC1D;;AAEA,yEAAyE;AACzE;EACE,qBAAqB,EAAE,8CAA8C;AACvE;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,aAAa,EAAE,0DAA0D;AAC3E","sourcesContent":["/* AddContact.css */\n.add-contact {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  /* width: 100vw; */\n  max-width: 430px;\n  max-height: 900px;\n  /* margin: 0 auto; */\n  height: 100vh;\n  background-color: rgb(243 243 243);\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-radius: 40px;\n  padding: 20px;\n  box-shadow: 0 4px 20px rgba(0,0,0,0.1);\n  position: relative; /* For positioning the header */\n}\n\n\n.profile {\n  font-size: 72px !important;\n  color: white;\n}\n\n.add-contact-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  background: #f7f7f7;\n  border-bottom: 1px solid #ccc;\n}\n\n.header-button, .header-button-link {\n  font-size: 17px;\n  color: #007aff;\n  background: none;\n  border: none;\n  padding: 10px;\n  cursor: pointer; /* Makes it clear that it's clickable */\n  text-decoration: none; /* Removes underline from links */\n}\n\n/* If you're using a class specifically for links, you can also do this */\n.header-button-link {\n  display: inline-block; /* Allows padding and width/height if needed */\n}\n\n.add-photo-section {\n  text-align: center;\n  padding: 20px;\n}\n\n.photo-placeholder {\n  width: 90px;\n  height: 90px;\n  background-color: #c7c7cc;\n  border-radius: 50%;\n  margin: 0 auto 10px;\n  /* Add your 'add photo' icon here */\n}\n\n.add-photo-button {\n  background-color: #c7c7cc;\n  border: none;\n  border-radius: 1em;\n  color: black;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.add-contact-form {\n  padding: 20px;\n}\n\n.add-contact-form input {\n  width: 100%;\n  font-size: 17px;\n  padding: 10px 0;\n  border: none;\n  border-bottom: 1px solid #ccc;\n  margin-bottom: 20px;\n}\n\n.add-contact-form input::placeholder {\n  color: #c7c7cc;\n}\n\n.add-field-button {\n  background: none;\n  border: none;\n  color: #007aff;\n  padding: 10px;\n  text-align: left;\n  width: 100%;\n  margin-bottom: 15px;\n  font-size: 17px;\n}\n\n/* For the submit button, if you still need it */\n.add-contact-form button[type=\"submit\"] {\n  display: none; /* Hide it if you're using the Done button in the header */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
